<app-card class="custom-grid" [loading]="(loading$ | async) ?? false">
  @if (weather$ | async; as weather) {
    @if (weather.now && weather.today) {
      <div class="today-wrapper">
        <div class="flex gap-4 justify-around">
          <div>
            <h3>
              <app-text-with-icon
                name="ic_location"
                [innerHTML]="
                  (weather.location.locationName | uppercase) ??
                  getGeoInfo(weather.location.lat, weather.location.lon)
                "
              />
            </h3>

            <p>
              {{ "weather.today" | translate }}
              {{ weather.today.minTemperature | temperature }} /
              {{ weather.today.maxTemperature | temperature }}
            </p>
          </div>

          <span
            class="weather-icon large"
            [class]="getWeatherIcon(weather.now.weather)"
          ></span>
          <div>
            <p>{{ "weather.now" | translate }}</p>
            <p class="large">
              @if (
                weather.weatherStation &&
                  weather.weatherStation.value &&
                  getWeatherStationTemperature(weather.weatherStation.value);
                as stationTemperature
              ) {
                {{ stationTemperature | temperature: "unicode" : false }}
              } @else {
                {{ weather.now.temperature | temperature: "unicode" }}
              }
            </p>
          </div>

          <div class="flex column align-start border-l">
            <app-text-with-icon name="ic_rain">
              {{ weather.today.precipitationChance | localizedPercent }}
            </app-text-with-icon>

            <app-text-with-icon
              name="ic_water"
              [hint]="getRainHint(weather.now.weather)"
            >
              @if (
                weather.weatherStation &&
                  weather.weatherStation.value &&
                  getWeatherStationRainGauge(weather.weatherStation.value);
                as stationRainGauge
              ) {
                {{ stationRainGauge | precipitation }}
              } @else {
                {{ weather.now.precipitationAmount | precipitation }}
              }
            </app-text-with-icon>
          </div>
        </div>

        <app-card class="bg-gray mt-2" style="--spacing: 1rem">
          <div class="flex gap-4">
            <table class="transparent">
              <tr>
                <th>{{ "weather.humidity" | translate }}:</th>
                <td>
                  @if (
                    weather.weatherStation &&
                      weather.weatherStation.value &&
                      getWeatherStationAirHumidity(
                        weather.weatherStation.value
                      );
                    as stationHumidity
                  ) {
                    {{ stationHumidity | localizedPercent }}
                  } @else {
                    {{ weather.today.humidity | localizedPercent }}
                  }
                </td>
              </tr>
              <tr>
                <th>{{ "weather.wind" | translate }}:</th>
                <td>
                  {{
                    weather.today.windSpeed | wind: weather.today.windDirection
                  }}
                </td>
              </tr>
            </table>
            <table class="transparent">
              <tr>
                <th>{{ "weather.sunRise" | translate }}:</th>
                <td>{{ weather.today.sunRise | time }}</td>
              </tr>
              <tr>
                <th>{{ "weather.sunSet" | translate }}:</th>
                <td>{{ weather.today.sunSet | time }}</td>
              </tr>
            </table>
          </div>

          @if (weather.weatherStation) {
            <small>
              {{ "weather.measured" | translate }}:
              {{ weather.weatherStation.lastSeenDate | relativeDate }} ({{
                "weather.measuredBy" | translate
              }}
              {{ weather.weatherStation.name }})
            </small>
          }
        </app-card>
      </div>
    }
    <div class="temperature-wrapper">
      <h3>{{ "weather.temperature" | translate }}</h3>
      <app-chart-temperature [hourlyForecast$]="hourlyForecast$" />
    </div>
    <div class="precipitation-wrapper">
      <h3>{{ "weather.precipitation" | translate }}</h3>
      <app-chart-precipitation [hourlyForecast$]="hourlyForecast$" />
    </div>
    @if (weather.extendedForecast) {
      <div class="forecast-wrapper">
        <h3>{{ "weather.forecast" | translate }}</h3>
        <table class="content">
          @for (day of weather.extendedForecast; track day.date) {
            <tr>
              <td class="pl-1">
                <b>{{ day.date | relativeDate: "day" }}</b
                ><br />
                {{ day.date | localizedDate: "d. MMM" }}
              </td>
              <td>
                <div class="flex">
                  <span
                    class="weather-icon"
                    [class]="getWeatherIcon(day.weather)"
                  ></span>
                  {{ day.minTemperature | temperature }} /
                  {{ day.maxTemperature | temperature }}
                </div>
              </td>
              <td>
                <app-text-with-icon name="ic_rain">
                  {{ day.precipitationChance | localizedPercent }}
                </app-text-with-icon>
              </td>
              <td>
                <app-text-with-icon
                  name="ic_water"
                  [hint]="getRainHint(day.weather)"
                >
                  {{ day.precipitationAmount | precipitation }}
                </app-text-with-icon>
              </td>
            </tr>
          }
        </table>
      </div>
    }
  } @else {
    {{ "weather.empty" | translate }}
  }
</app-card>
